import { render } from "./callToActionDefaultBlock.vue?vue&type=template&id=7f0c6467&scoped=true&ts=true"
import script from "./callToActionDefaultBlock.vue?vue&type=script&lang=ts"
export * from "./callToActionDefaultBlock.vue?vue&type=script&lang=ts"

import "./callToActionDefaultBlock.vue?vue&type=style&index=0&id=7f0c6467&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0c6467"]])

export default __exports__